import * as React from 'react';
import { TextInput } from "soprasteria-ui-library";
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";
import { formatCurrency } from '../../../helpers/CurrencyHelper';

interface IInvoiceInformation {
    isSysAdmin: boolean;
    invoiceVerNr: string;
    invoiceStatus: string;
    invoiceDate: Date;
    invoiceDueDate: Date;
    invoiceAmount: number;
    umbrellaOrganisation: string;
    orgNumber: string;
    careProviderName: string;
    careProviderNumber: string;
    invoiceReference: string;
    createdByInformation: string;
    approvedByInformation: string;
    attestedByInformation: string;
    exportedDate?: Date;
    numberOfUniquePatients?: number;
}

export const InvoiceInformation: React.FunctionComponent<IInvoiceInformation> = ({ isSysAdmin, invoiceVerNr, invoiceStatus, invoiceDate, invoiceDueDate, invoiceAmount, umbrellaOrganisation, orgNumber, careProviderName, careProviderNumber, invoiceReference, createdByInformation, approvedByInformation, attestedByInformation, exportedDate, numberOfUniquePatients }) => {

    return (
        <>
            <div className="col-6">
                <TextInput label="Verifikationsnummer" name="readonly" defaultValue={invoiceVerNr} readonly inlineLabel />
                <TextInput label="Fakturadatum" name="readonly" defaultValue={dateTimeToDateString(invoiceDate)} readonly inlineLabel />
                <TextInput label="Förfallodatum" name="readonly" defaultValue={dateTimeToDateString(invoiceDueDate)} readonly inlineLabel />
                <TextInput label="Fakturastatus" name="readonly" defaultValue={invoiceStatus} readonly inlineLabel />
                <TextInput label="Totalt fakturerat belopp" name="readonly" defaultValue={formatCurrency(invoiceAmount)} readonly inlineLabel />
            </div>
            <div className="col-6">
                {
                    umbrellaOrganisation ?
                        <TextInput label="Vårdgivare" name="readonly" defaultValue={umbrellaOrganisation} readonly inlineLabel />
                        : null
                }
                <TextInput label="Organisationsnummer" name="readonly" defaultValue={formatPersonalSecurityNumberAndOrganisationNumber(orgNumber)} readonly inlineLabel />
                <TextInput label="Mottagningsnamn" name="readonly" defaultValue={careProviderName} readonly inlineLabel />
                <TextInput label="Mottagningsnummer" name="readonly" defaultValue={careProviderNumber} readonly inlineLabel />
                <TextInput label="Extern fakturareferens" name="readonly" defaultValue={invoiceReference} readonly inlineLabel />
            </div>
            {
                numberOfUniquePatients ?
                    <>
                        <div className="col-6">
                            <TextInput label="Antal patienter" name="readonly" defaultValue={numberOfUniquePatients.toString()} readonly inlineLabel />
                        </div>
                        <div className="col-6" />
                    </> : null
            }
            {
                isSysAdmin ?
                    <>
                        <div className="col-6">
                            <TextInput label="Skapad av" name="readonly" defaultValue={createdByInformation} readonly inlineLabel />
                            <TextInput label="Godkänd av" name="readonly" defaultValue={approvedByInformation} readonly inlineLabel />
                        </div>
                        <div className="col-6">
                            <TextInput label="Attesterad av" name="readonly" defaultValue={attestedByInformation} readonly inlineLabel />
                            <TextInput label="Skickad till Raindance" name="readonly" defaultValue={dateTimeToDateString(exportedDate)} readonly inlineLabel />
                        </div>
                    </> : null
            }
        </>
    )
}

